import { environment } from '../../environments/environment';

export const config = {
  environment: environment.environment,
  production: environment.production,
  
  apiUrl: environment.apiUrl,
  
  isDevelopment: environment.environment === 'development',
  isProduction: environment.production,
  
  auth: {
    whitelist401Routes: [
      '/auth/login',
      '/api/templates/public', // Add public templates list
      '/api/templates/' // Add public template detail (will match /api/templates/:id)
    ],
    refreshEndpoints: ['/refresh', '/token/refresh']
  },

  messageHandling: {
    // Response codes that should not trigger message display
    whitelistedCodes: ['OK', 'NO_MESSAGE', 'SUCCESS']
  },
  
};